import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ChipWrapper = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "maxWidth",
})(({ maxWidth, theme }) => ({
  position: "relative",
  maxWidth: maxWidth ? maxWidth : "100%",
  padding: theme.spacing(0.5),

  "& .MuiChip-root": {
    marginTop: 0,
  },

  "& > div": {
    maxWidth: "100%",
  },
}));
